import { Page } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';

import { companiesApi } from 'apis/companies';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import {
  contactLoadFailed,
  contactLoading,
  contactNotFound,
  noContactSelected,
} from '../../utils/contactDetails.utils';

import { CompanyInfo } from './components/companyInfo/companyInfo';
import { CompanyRelatedUsers } from './components/companyRelatedUsers/companyRelatedUsers';

export function CompanyDetails(): JSX.Element {
  const { id } = useAppPathParams('/contacts/company/:id');
  const [getCompany, { data, isFetching, isError }] =
    companiesApi.useLazyReadCompanyQuery();

  useEffect(() => {
    if (id) {
      getCompany({ id: id });
    }
  }, [id, getCompany]);

  if (!id) {
    return noContactSelected;
  }

  if (isFetching) {
    return contactLoading;
  }

  if (isError) {
    return contactLoadFailed;
  }

  if (!data?.data) {
    return contactNotFound;
  }

  return (
    <Page>
      <Page.Body>
        <Page.Section>
          <CompanyInfo company={data.data} />
        </Page.Section>

        <Page.Section title="Related users">
          <CompanyRelatedUsers companyId={data.data.id} />
        </Page.Section>
      </Page.Body>
    </Page>
  );
}
